import { useEffect, useMemo } from 'react';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import { FileDownloadTwoTone } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Document } from '@api/Trinium/Endpoints/Document/types';
import { useModalProvider } from '@components/Modals/ModalContext';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import useFetch from '@hooks/useFetch';

import styles from '../DataGrid.DocumentControl.module.css';

/**
 * View/Print Document
 */
export default function ViewPrintAction() {
	const { number: terminalNumber } = useCurrentTerminal();
	const modalContext = useModalProvider();
	const { queueModalAnnouncement } = modalContext;
	const { fetchFile, isLoading, isError, errorMessage } = useFetch();
	const gridApiRef = useGridApiContext();
	const selectedRowsMap = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const selectedRows = useMemo<Document[]>(() => Array.from(selectedRowsMap.values()) as Document[], [selectedRowsMap]);

	const selectedDocumentIds = useMemo(() => selectedRows.map((row) => row.id), [selectedRows]);

	useEffect(() => {
		if (isError && errorMessage) {
			queueModalAnnouncement({
				message: errorMessage,
				severity: 'error'
			});
		}
	}, [isError, queueModalAnnouncement, errorMessage]);

	const handleBtnClick = () => {
		void fetchFile(
			`/${terminalNumber}/documents`,
			'PUT',
			JSON.stringify({
				action: 'getDocuments',
				data: {
					docIds: selectedDocumentIds
				}
			})
		);
	};

	return (
		<IconButton
			title='View/Print Document'
			onClick={handleBtnClick}
			disabled={!selectedDocumentIds.length || isLoading}
			loading={isLoading}
			className={styles['icon-btn']}
		>
			<FileDownloadTwoTone fontSize='small' />
		</IconButton>
	);
}
